import angular from 'angular';
import shadowSettings from '../shadowSettings';

import component from './dealerPhoneCta.component';

export default angular.module('dealerPhoneCta', [
    shadowSettings
])

.component('dealerPhoneCta', component)

.name;
